// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2Tr2e","FooterLinks":"Footer_FooterLinks__v7OaO","Item":"Footer_Item__2dWK8"};